import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button, Input, TextArea } from '@/ui';

export const StyledApproveButton = styled(Button)`
  &.ant-btn {
    background-color: ${COLORS.STATUS_SUCCESS} !important;
    border-color: ${COLORS.STATUS_SUCCESS} !important;
    color: ${COLORS.WHITE} !important;

    &:hover,
    &:focus {
      filter: brightness(1.1);
    }
  }
`;

export const StyledFieldLabel = styled.label`
  display: block;
  ${pickThemeFontStyles('12', '16', 'BOLD')}
  color: ${COLORS.TEXT_HINT};
  letter-spacing: 0.48px;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
`;

export const StyledField = styled.div`
  display: flex;
  flex-direction: column;

  &:last-of-type {
    .ant-form-item {
      margin-bottom: 0;
    }
  }
`;

export const StyledFieldInput = styled(Input)`
  &.ant-input {
    background-color: ${COLORS.GRAY_7};
    border: 1px solid ${COLORS.GRAY_3};
    border-radius: 0.625rem;
    padding: 0.6875rem 0.8125rem;
    ${pickThemeFontStyles('14', '20')}
    color: ${COLORS.TEXT_PRIMARY};
  }
`;

export const StyledFieldTextArea = styled(TextArea)`
  &.ant-input {
    background-color: ${COLORS.GRAY_7};
    border: 1px solid ${COLORS.GRAY_3};
    border-radius: 0.625rem;
    padding: 0.6875rem 0.8125rem;
    ${pickThemeFontStyles('14', '20')}
    color: ${COLORS.TEXT_PRIMARY};
  }

  &:disabled {
    resize: none;
  }
`;
